/**
 * 编辑状态的行程state
 */
import {
  EDIT_TRIP_EDIT,
  GET_TRIP_EDIT,

  EDIT_TRIP_EDIT_POIS,
  GET_TRIP_EDIT_POIS,

  EDIT_TRIP_EDIT_CITIES,
  GET_TRIP_EDIT_CITIES,

  EDIT_TRIP_MODIFY_POIS,
  GET_TRIP_MODIFY_POIS
} from '../../actionTypes';
import { PENDING, FAILURE, SUCCESS } from '../../../utils/status';


import {combineReducers} from 'redux';



const INIT_STATE = {
  data: null,
  status: undefined
};


// trip-edit页的行程
function tripEdit(state = INIT_STATE, action) {
  let nextState;

  if (action.type === EDIT_TRIP_EDIT) {
    nextState = {
      ...state,
      data: action.data
    };
  } else if (action.type === GET_TRIP_EDIT) {
    switch (action.status) {
      case PENDING:
        nextState = {
          ...state,
          status: action.status
        };
        break;
      case FAILURE:
      case SUCCESS:
        nextState = {
          ...state,
          status: action.status,
          data: action.data
        };
        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}



// trip-edit-pois页的行程
function tripEditPois(state = INIT_STATE, action) {
  let nextState;

  if (action.type === EDIT_TRIP_EDIT_POIS) {
    nextState = {
      ...state,
      data: action.data
    };
  } else if (action.type === GET_TRIP_EDIT_POIS) {
    switch (action.status) {
      case PENDING:
        nextState = {
          ...state,
          status: action.status
        };
        break;
      case FAILURE:
      case SUCCESS:
        nextState = {
          ...state,
          status: action.status,
          data: action.data
        };
        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}

// trip-edit-cities页的行程
function tripEditCities(state = INIT_STATE, action) {
  let nextState;

  if (action.type === EDIT_TRIP_EDIT_CITIES) {
    nextState = {
      ...state,
      data: action.data
    };
  } else if (action.type === GET_TRIP_EDIT_CITIES) {
    switch (action.status) {
      case PENDING:
        nextState = {
          ...state,
          status: action.status
        };
        break;
      case FAILURE:
      case SUCCESS:
        nextState = {
          ...state,
          status: action.status,
          data: action.data
        };
        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}


// trip-edit-pois页的行程
function tripModifyPois(state = INIT_STATE, action) {
  let nextState;

  if (action.type === EDIT_TRIP_MODIFY_POIS) {
    nextState = {
      ...state,
      data: action.data
    };
  } else if (action.type === GET_TRIP_MODIFY_POIS) {
    switch (action.status) {
      case PENDING:
        nextState = {
          ...state,
          status: action.status
        };
        break;
      case FAILURE:
      case SUCCESS:
        nextState = {
          ...state,
          status: action.status,
          data: action.data
        };
        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }

  return nextState;
}




export default combineReducers({
  tripEdit,
  tripEditPois,
  tripEditCities,
  tripModifyPois,
});



// WEBPACK FOOTER //
// ./src/store/reducers/trip/editing.js